t = require('app/scripts/views/internal/teacup-with-helpers')('template_banner')

module.exports = t.renderable ({ isVisible, isPublic, teamName }) ->
  if isVisible
    t.div '.template-banner-message', { class: t.classify(public: isPublic) }, ->
      if isPublic
        t.span '.icon-sm.icon-public'
        t.span -> t.format 'this-is-a-public-template-for-anyone-on-the-internet-to-copy'
      else
        t.span -> t.l('this-is-a-template-for-members-of-team-to-copy', { teamName })

    t.a '.button.primary.js-copy-template', { tabindex: "0", href: '#', title: t.l('create-board-from-template') }, ->
      t.format 'create-board-from-template'

    t.a '.button.js-share-template', { tabindex: "0", href: '#', title: t.l('share-template') }, ->
      t.format 'share-template'
